import { type UpdatePolicyRequestModel } from '@/shared/api'

import type { PolicyFormModel } from '../ui/PolicySection'

export function getPolicyRequestByFormValues(values: PolicyFormModel): {
  data: UpdatePolicyRequestModel
} {
  return {
    data: {
      fileId:
        values.file && typeof values.file.id === 'string' ? values.file.id : '',
      languageCode: values.languageCode,
      type: values.type,
    },
  }
}
